<template>
  <div class="footer">
    <a-layout-footer style="background: transparent; padding-left: 0; color: #9A999A; text-align: center;" v-if="winStatus">
      Copyright © 2026 COTERNLAX LABS。 All Right Reserved.
    </a-layout-footer>

    <div class="footer-h5" v-else>
      <div class="inner flex">
        <div class="flex-1 item" v-for="(item, index) in list" :key="index" @click="$router.push(item.path)">
          <template v-if="index != 2">
            <a-icon :type="item.icon" :style="{ 'color': $route.path == item.path ? '#EFC02A' : '#fff', 'fontSize': '20px' }" />
            <div>{{ item.label }}</div>
          </template>
          <template v-else>
            <div class="center-fab">
              <a-icon type="appstore" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        { label: this.$t('Common.DASHBOARD'), icon: 'home', path: '/home'  }, 
        { label: this.$t('Common.WALLET'), icon: 'wallet', path: '/wallet'  }, 
        {  path: '/portfolio'  }, 
        { label: this.$t('Common.REFERRAL PROGRAM'), icon: 'usergroup-add', path: '/referral'  }, 
        { label: this.$t('userLogin.My Profile'), icon: 'user', path: '/profile/xs' }, 
      ],
      winStatus: window.innerWidth > 768
    }
  },
  methods: {
    handleResize() {
      this.winStatus = window.innerWidth > 768;
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style lang="scss" scoped>
a {
  color: #252F4A;
}


@media screen and (max-width: 576px) {
  .footer-h5 {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 99999;
    width: 100vw;
    padding: 7px 0;
    border-top: 1px solid var(--panel-border);
    background-color: #0a0a0a;
    box-shadow: 0 -4px 24px rgba(239,192,42,.10);

    border-radius: 20px 20px 0 0;

    .inner {
      width: 100%;
      padding: 10px 0 15px;
    }
    .item {
      text-align: center;
      cursor: pointer;
      div {
        margin-top: 5px;
        font-size: 11px;
        color: #fff;
      }
    }

    .item .center-fab {
      margin: -12px auto 0;
      width: 48px;
      height: 48px;
      border-radius: 50%;
      background: var(--gold-grad);
      border: 3px solid #0a0a0a;
      box-shadow: 0 4px 14px rgba(239,192,42,.40);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #1A1A1A;

      i {
        color: #1A1A1A;
        font-size: 22px;
      }
    }
  }
}
</style>